import React from 'react';
import { BlockTitleFormatData } from '@modules/proposal/ProposalBuilderPage/ProposalForm';

export function findTitleFormat(formats: BlockTitleFormatData[] | null | undefined, id: string | null | undefined) {
  return id ? (formats || []).find(format => format.id === id) : undefined;
}

export const newTitleFormatId = () => `tf-${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`;

/**
 * Inline style for a title wrapped in a saved format. Only properties the format sets are returned,
 * and each has a matching `btf-*` class (index.scss) that makes the title's rich-text children
 * inherit it — so a format wins over sizes/fonts typed into the title by hand, and properties the
 * format leaves empty keep the title's own formatting.
 */
export function titleFormatStyle(format?: Partial<BlockTitleFormatData> | null): { style: React.CSSProperties; className: string } {
  const style: React.CSSProperties = {};
  const classes: string[] = ['block-title-format'];
  if (!format) return { style, className: '' };

  if (format.font?.family) {
    style.fontFamily = format.font.family;
    classes.push('btf-font');
  }
  if (format.fontSize) {
    style.fontSize = `${format.fontSize}px`;
    style.lineHeight = 1.25;
    classes.push('btf-size');
  }
  if (format.fontWeight) {
    style.fontWeight = format.fontWeight as React.CSSProperties['fontWeight'];
    classes.push('btf-weight');
  }
  if (format.color) {
    style.color = format.color;
    classes.push('btf-color');
  }
  if (format.italic) {
    style.fontStyle = 'italic';
    classes.push('btf-italic');
  }
  if (format.uppercase) {
    style.textTransform = 'uppercase';
    classes.push('btf-upper');
  }
  return { style, className: classes.join(' ') };
}
